// extracted by mini-css-extract-plugin
module.exports = {"formCheckbox":"IRaet","gray":"IRbn","input":"IRmp","label":"IRt7"};